<template>
  <div class="flag-container">
    <button type="button" v-on:click="($i18n.locale = 'es'), firstFocus()">
      <span title="Español" class="flag-icon flag-icon-es">.</span>
    </button>
    &nbsp;
    <button type="button" v-on:click="($i18n.locale = 'en'), firstFocus()">
      <span title="English" class="flag-icon flag-icon-en">.</span>
    </button>
    &nbsp;
    <button type="button" v-on:click="($i18n.locale = 'it'), firstFocus()">
      <span title="Italiano" class="flag-icon flag-icon-it">.</span>
    </button>
    &nbsp;
    <button type="button" v-on:click="($i18n.locale = 'pt'), firstFocus()">
      <span title="Português" class="flag-icon flag-icon-pt">.</span>
    </button>
    &nbsp;
    <button type="button" v-on:click="($i18n.locale = 'fr'), firstFocus()">
      <span title="Français" class="flag-icon flag-icon-fr">.</span>
    </button>
  </div>
</template>

<style src="./css/languageSelector.css"></style>

<script>
export default {
  props: ["focus"],
  name: "LanguageSelector",
  methods: {
    firstFocus() {
      if (this.focus != null) {
        document.querySelector(this.focus).focus();
      }
    }
  }
};
</script>
